import './index.css';

import { ThemeProvider } from '@mui/styles';
import { createRoot } from 'react-dom/client';
import { logEnvironmentConfig } from './config/environment';
import ErrorBoundary from './layout/ErrorBoundary';
import reportWebVitals from './reportWebVitals';
import theme from './Theme';

// Enable onboarding test mode helpers in console
import './features/onboarding/enableTestMode';

// Initialize and log environment configuration
logEnvironmentConfig();

// Check if running in Electron (desktop mode)
const isElectron = window.navigator.userAgent.includes('Electron') ||
                   (window as any).electron?.isElectron === true;

// Dynamically import the appropriate App component
const AppPromise = isElectron
  ? import('./app.desktop')
  : import('./app');

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

// Load and render the appropriate App
AppPromise.then(({ default: App }) => {
  root.render(
    <ThemeProvider theme={theme}>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </ThemeProvider>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
